import { useEffect, useRef } from 'react';
import { isOnboardingWizardRoute } from '../utils/onboardingCompleteSave';
import { isSessionDead } from '../lib/sessionDead';
import { keepPendingOnboardingSaveGoing, markOnboardingConfirmed } from '../utils/onboardingPendingGate';
/** Skip onboarding redirect while user is on wizard routes (#653). */
export default function useOnboardingProfileGate(auth, setOnboardingChecked) {
  const onboardingCheckStarted = useRef(false);

  useEffect(() => {
    if (!auth.isAuthenticated || !auth.accessToken) return;
    if (onboardingCheckStarted.current) return;
    const path = typeof window !== 'undefined' ? window.location.pathname : '';
    if (isOnboardingWizardRoute(path)) {
      setOnboardingChecked(true);
      return;
    }
    onboardingCheckStarted.current = true;

    (async () => {
      if (isSessionDead()) {
        setOnboardingChecked(true);
        return;
      }
      try {
        const res = await fetch('https://api.maestroaudio.net/api/user/profile', {
          headers: { Authorization: `Bearer ${auth.accessToken}` },
        });
        if (!res.ok) throw new Error('profile fetch failed');
        const data = await res.json();
        const tier = data?.profile?.subscription_tier;
        const hadTrial = data?.profile?.had_trial;
        const hasStripe = !!data?.profile?.stripe_customer_id;
        if (tier === 'pending_checkout' || (tier === 'expired' && !hadTrial && !hasStripe)) {
          setOnboardingChecked(true);
          return;
        }
        if (data?.profile?.onboarding_completed) {
          markOnboardingConfirmed();
        } else if (!keepPendingOnboardingSaveGoing()) {
          localStorage.removeItem('maestro_onboarding_complete');
          if (!isOnboardingWizardRoute(window.location.pathname)) {
            window.location.replace('/onboarding/language');
            return;
          }
        }
      } catch { keepPendingOnboardingSaveGoing(); }
      setOnboardingChecked(true);
    })();
  }, [auth.isAuthenticated, auth.accessToken, setOnboardingChecked]);
}
